export function truncateDays(val) {
  return Math.floor(val * 100) / 100;
}

export function formatDays(days) {
  return Math.abs(days) > 1 ? truncateDays(days) + ' days' : truncateDays(days) + ' day';
}
